import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Card, Table } from 'react-bootstrap';
import EmptyStateNoRecord from '../lib/EmptyStateNoRecord';
import Loading from '../common/Loading';
import XBadge from '../lib/XBadge';
import { XRPSCAN_API_URL } from '../../config';
import { getLedgerEntryTypeLabel, handleResponse } from '../common/Helpers';
import MPTokenTag from '../lib/MPTokenTag';

const AccountMPToken = (props) => {
    const { address } = props;
    const [ mptokens, setMptokens ] = useState([]);
    const [ mptokenIssuances, setMptokenIssuances] = useState([]);
    const [ loading, setLoading ] = useState(false);

    // Fetch MPTokens
    useEffect(() => {
        setLoading(true);
        fetch(`${XRPSCAN_API_URL}/account/${address}/mptokens`)
            .then(handleResponse)
            .then((data) => {
                setMptokens(data);
            })
            .catch(() => {
                setMptokens([])
            })
            .finally(() => {
                setLoading(false);
            });
            return () => {
                setMptokens([]);
            }
    }, [address]);

    // Fetch MPToken Issuances
    useEffect(() => {
        setLoading(true);
        fetch(`${XRPSCAN_API_URL}/account/${address}/mptokenissuances`)
            .then(handleResponse)
            .then((data) => {
                setMptokenIssuances(data);
            })
            .catch(() => {
                setMptokenIssuances([])
            })
            return () => {
                setMptokenIssuances([]);
            }
    }, [address]);

    if (loading) {
        return <Loading/>;
    }

    return (
        <>
            {mptokenIssuances?.length > 0 &&
            <Card className='shadow-sm'>
                <Card.Body>
                    <Card.Text>
                        <h6>XLS-33 MPToken Issuances</h6>
                    </Card.Text>
                    <Table responsive>
                        <thead>
                            <tr>
                                <th className="text-center">#</th>
                                <th className="text-center">Type</th>
                                {/* <th className="text-left">Ticker</th> */}
                                <th className="text-left">MPT Issuance</th>
                                <th className="text-right">Circulating Amount</th>
                                <th className="text-right">Max Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            { mptokenIssuances.map((mpti, index) =>
                            <tr key={index}>
                                <td className="text-center">{index+1}</td>
                                <td className="text-center">
                                    <XBadge variant="info" className="text-uppercase">{getLedgerEntryTypeLabel(mpti.LedgerEntryType)}</XBadge>
                                </td>
                                {/* <td className="text-left text-monospace">$USD</td> */}
                                <td className="text-left">
                                    <span className="address-tag text-monospace"><Link to={`/mpt/${mpti.mpt_issuance_id}`}>{mpti.mpt_issuance_id}</Link></span>
                                </td>
                                <td className="text-right">
                                    <MPTokenTag mpt_issuance_id={mpti.mpt_issuance_id}>{mpti.OutstandingAmount ?? 0}</MPTokenTag>
                                </td>
                                <td className="text-right">
                                    <MPTokenTag mpt_issuance_id={mpti.mpt_issuance_id}>{mpti.MaximumAmount ?? 0}</MPTokenTag>
                                </td>
                            </tr>
        					)}
		        		</tbody>
			        </Table>
                </Card.Body>
            </Card>
            }
            {mptokens?.length > 0 &&
            <Card className='shadow-sm'>
                <Card.Body>
                    <Card.Text>
                        <h6>XLS-33 MPTokens owned</h6>
                    </Card.Text>
                    <Table responsive>
                        <thead>
                            <tr>
                                <th className="text-center">#</th>
                                <th className="text-center">Type</th>
                                {/* <th className="text-left">Ticker</th> */}
                                <th className="text-left">MPT Issuance</th>
                                <th className="text-right">Amount</th>
                                {/* Enable this field after TokenEscrow amendment activation */}
                                {/* <th className="text-right">Locked</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            { mptokens.map((mpt, index) =>
                            <tr key={index}>
                                <td className="text-center">{index+1}</td>
                                <td className="text-center">
                                    <XBadge variant="info" className="text-uppercase">{mpt.LedgerEntryType}</XBadge>
                                </td>
                                {/* <td className="text-left text-monospace">$USD</td> */}
                                <td className="text-left">
                                    <span className="address-tag text-monospace"><Link to={`/mpt/${mpt.MPTokenIssuanceID}`}>{mpt.MPTokenIssuanceID}</Link></span>
                                </td>
                                <td className="text-right text-monospace">
                                    <MPTokenTag mpt_issuance_id={mpt.MPTokenIssuanceID}>{mpt.MPTAmount ?? 0}</MPTokenTag>
                                </td>
                                {/* Enable this field after TokenEscrow amendment activation */}
                                {/* <td className="text-right text-monospace">
                                    <MPTokenTag mpt_issuance_id={mpt.MPTokenIssuanceID}>{mpt.LockedAmount ?? 0}</MPTokenTag>
                                </td> */}
                            </tr>
        					)}
		        		</tbody>
			        </Table>
                </Card.Body>
            </Card>
            }
            {!loading && mptokenIssuances?.length === 0 && mptokens?.length === 0 &&
                <EmptyStateNoRecord title="No MPTokens">
                    <div className='mb-3'>This account does not own any XLS-33 MPTokens.</div>
                    {/* <Link to="/mptokens">
                        <Button variant="info" size="sm">View all XLS-33 MPTokens &rarr;</Button>
                    </Link> */}
                </EmptyStateNoRecord>
            }
        </>
    )
}

AccountMPToken.propTypes = {
    address: PropTypes.string.isRequired,
}

export default AccountMPToken;